import styled from 'styled-components';
import { COLORS, stickyTopOffset } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';

export const ContainerWrapper = styled.div`
  padding: 0 15rem;
`;

// The table's sticky header stacks below this block by its measured height.
export const StickyTop = styled.div`
  position: sticky;
  top: ${stickyTopOffset};
  z-index: 3;
  max-width: 1440rem;
  margin: 30rem auto 0;
  padding-top: 20rem;
  background-color: ${COLORS.BACKGROUND};
`;

export const BackWrapper = styled.div`
  padding-bottom: 20rem;
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: center;
  min-height: 700rem;
  max-width: 1440rem;
  width: 100%;
  border-radius: 0 0 20rem 20rem;
  background-color: ${COLORS.WHITE};
  margin: 0 auto 50rem;
  padding: 0 15rem 15rem;

  ${respondTo.smallLaptop`
    padding-bottom: 50rem;
  `}

  ${respondTo.smallTablet`
    padding-bottom: 20rem;
  `}
`;

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 20rem 20rem 0 0;
  background-color: ${COLORS.WHITE};
  padding: 15rem 15rem 20rem;

  ${respondTo.smallLaptop`
    padding-top: 50rem;
  `}

  ${respondTo.smallTablet`
    padding-top: 20rem;
  `}
`;

export const Title = styled.span`
  display: block;
  font-weight: 400;
  font-size: 24rem;
  color: ${COLORS.BLACK};
`;

export const NoContentLabel = styled.label`
  text-align: center;
  font-weight: 300;
  font-size: 18rem;
  color: ${COLORS.BLACK};

  ${respondTo.bigPhone`
    font-size: 16rem;
  `}
`;
